module YVR.Utilities.Logger {
	//#region PRIVATE VARIABLES

	let index = 1;

	//#endregion


	//#region PUBLIC METHODS

	/**
	 * Logs message to the console.
	 */
	export function log(...data) {
		// We will only log if the console exists. All modern browsers have it, but there is a bug in IE8 where referencing the console
		// will error out if the developer tools haven't been opened. Once they are opened and then even closed the console object will exist.
		if (typeof console !== 'undefined') {
			const msg = `[${index++}]`;

			if ((YVR as any).Tokens && (YVR as any).Tokens.DEBUG) {
				if (data.length === 1 && typeof data[0] === 'string') {
					console.log(`${msg} ${data[0]}`);
				} else {
					console.log(msg, data);
				}
			}
		}
	}

	/**
	 * Logs message to the console.
	 */
	export function error(...data) {
		if (typeof console !== 'undefined') {
			const msg = `[${index++}]`;

			if ((YVR as any).Tokens && (YVR as any).Tokens.DEBUG) {
				if (data.length === 1 && typeof data[0] === 'string') {
					console.log(`${msg} ${data[0]}`);
				} else {
					console.log(msg, data);
				}
			}
		}
	}

	//#endregion
}
